<template>
  <div
    class="t-Tree"
    :class="{'-child': isChild}"
  >
    <div
      v-for="(node, index) in nodes"
      :key="index + node[nodeKey] + node[labelKey]"
      class="t-Tree-Node"
    >
      <div class="t-Tree-Content">
        <div
          v-if="node[childrenKey] && hideExpander === false"
          :class="['t-Tree-Expander', { '-expanded': isExpanded[node[nodeKey]] }, { '-cursorPointer': node[childrenKey] }]"
        >
          <Icon
            v-if="node[childrenKey]"
            color="#486581"
            :handle-click="() => toggle(node[nodeKey])"
            name="DropDown"
            size="24"
          />
        </div>

        <slot
          :node="node"
          :is-expanded="isExpanded"
        />
      </div>
      <template v-if="node[childrenKey] && node[childrenKey].length > 0">
        <TreeRender
          :nodes="node[childrenKey]"
          :node-key="nodeKey"
          :label-key="labelKey"
          :children-key="childrenKey"
          :class="{ '-hidden': isExpanded[node[nodeKey]] === false }"
          is-child
        >
          <template #default="{ node: nodeChild, isExpanded: isExpandedChild }">
            <slot
              :node="nodeChild"
              :is-expanded="isExpandedChild"
            />
          </template>
        </TreeRender>
      </template>
      <Divider v-if="!isChild && divider"></Divider>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue';
import Divider from '../Divider/Divider.vue';

export default {
  name: 'TreeRender',
  components: {
    Icon,
    Divider,
  },
  props: {
    childrenKey: {
      type: String,
      default: 'children',
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    nodeKey: {
      type: String,
      required: true,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    nodes: {
      type: Array,
      default: () => [],
    },
    divider: {
      type: Boolean,
      default: false,
    },
    hideExpander: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: {},
    };
  },
  watch: {
    nodes(nodes) {
      this.createExpandedData(nodes);
    },
  },
  created() {
    this.createExpandedData(this.nodes);
  },
  methods: {
    createExpandedData(nodes = []) {
      this.isExpanded = nodes.reduce((accumulator, node) => {
        const nodeKey = node[this.nodeKey];
        return {
          ...accumulator,
          [nodeKey]: true,
        };
      }, {});
    },
    toggle(key) {
      this.isExpanded = {
        ...this.isExpanded,
        [key]: !this.isExpanded[key],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.t-Tree {
  &.-hidden {
    display: none;
  }

  &.-child {
    padding-left: 40px;
    padding-right: 0;
  }
}

.t-Tree-Node {
  margin: var(--track-spacing-md) 0;
}

.t-Tree-Content {
  align-items: center;
  display: flex;
  user-select: none;
}

.t-Tree-Expander {
  --size: var(--track-spacing-bg);

  height: var(--size);
  margin-right: var(--track-spacing-sm);
  transform: rotate(-90deg);
  min-width: var(--size);

  &.-expanded {
    transform: rotate(0deg);
  }

  &.-cursorPointer {
    cursor: pointer;
  }
}
</style>
